module.exports = __webpack_public_path__ + "static/media/our-proejcts-img3.630bcb15.png";